import { createSlice } from "@reduxjs/toolkit";
import { RootGlobalState } from "../stores/global";

export interface QuestionnaireState {
  valid: boolean;
  answers: { [key: string]: string };
}
function generateAnswersFromLocalStorage() {
  const answer: any = {};

  for (let i = 0; i < localStorage.length; i++) {
    const element = localStorage.key(i);

    if (element && element.indexOf("Questionnaire") >= 0)
      answer[element] = localStorage.getItem(element);
  }
  return answer;
}

const initialState: QuestionnaireState = {
  valid: false,
  answers: generateAnswersFromLocalStorage(),
};

export const GlobalSlice = createSlice({
  name: "QuestionnaireState",
  initialState,
  reducers: {
    setAnswer(
      state: QuestionnaireState,
      action: { payload: { key: string; value: string } }
    ) {
      state.answers[action.payload.key] = action.payload.value;
      localStorage.setItem(
        `Questionnaire-${action.payload.key}`,
        action.payload.value
      );
    },
    clearAnswer(
      state: QuestionnaireState,
      action: { payload: { key: string } }
    ) {
      if (state.answers) delete state.answers[action.payload.key];
      localStorage.removeItem(`Questionnaire-${action.payload.key}`);
    },
    setQuestionnaireValid(state: QuestionnaireState) {
      state.valid = true;
    },
    setQuestionnaireInvalid(state: QuestionnaireState) {
      state.valid = false;
    },
  },
});
export const {
  setAnswer,
  clearAnswer,
  setQuestionnaireInvalid,
  setQuestionnaireValid,
} = GlobalSlice.actions;
export const selectQuestionnaireValidStatus = (state: RootGlobalState) =>
  state.questionnaire.valid;

export const selectRawQuestionnaireAnswer = (state: RootGlobalState) =>
  state.questionnaire.answers;
export const selectQuestionnaireAnswer = (state: RootGlobalState) => {
  const res: any = {};
  Object.entries(state.questionnaire.answers).forEach(([key, value]) => {
    const _key = key.replace("Questionnaire-", "");
    res[_key] = value;
  });
  return res;
};

export default GlobalSlice.reducer;
